let paymentMethodRoutes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'payment-methods/outgoing', name: 'payment-methods.outgoing', component: () => import('./pages/outgoing/Index.vue') },
      { path: 'payment-methods/outgoing/create', name: 'payment-methods.outgoing.create', component: () => import('./pages/outgoing/Create.vue') },
      { path: 'payment-methods/outgoing/:id/edit', name: 'payment-methods.outgoing.edit', component: () => import('./pages/outgoing/Edit.vue') },
      { path: 'payment-methods/incoming', name: 'payment-methods.incoming', component: () => import('./pages/incoming/Index.vue') },
      { path: 'payment-methods/incoming/create', name: 'payment-methods.incoming.create', component: () => import('./pages/incoming/Create.vue') },
      { path: 'payment-methods/incoming/:id/edit', name: 'payment-methods.incoming.edit', component: () => import('./pages/incoming/Edit.vue') },
    ]
  }
];

export default paymentMethodRoutes;
